import { withApiBase } from "./base";

function headers(userId, contentType = true) {
  const h = { "X-User-Id": String(userId) };
  if (contentType) h["Content-Type"] = "application/json";
  return h;
}

export async function patchMe(userId, payload) {
  const res = await fetch(withApiBase("/users/me"), {
    method: "PATCH",
    headers: headers(userId),
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Cannot update profile");
  }
}

export async function replaceSports(userId, sports) {
  const res = await fetch(withApiBase("/users/me/sports"), {
    method: "PUT",
    headers: headers(userId),
    body: JSON.stringify({ sports }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Cannot update sports");
  }
}

export async function uploadPhoto(userId, file) {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch(withApiBase("/users/me/photos"), {
    method: "POST",
    headers: { "X-User-Id": String(userId) },
    body: form,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Cannot upload photo");
  }

  const ct = res.headers.get("content-type") || "";
  if (!ct.includes("application/json")) {
    return null;
  }

  const data = await res.json().catch(() => null);
  return data;
}

export async function deletePhoto(userId, photoId) {
  const res = await fetch(withApiBase(`/users/me/photos/${photoId}`), {
    method: "DELETE",
    headers: { "X-User-Id": String(userId) },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Cannot delete photo");
  }
}

export async function setAvatar(userId, photoId) {
  const res = await fetch(withApiBase("/users/me/avatar"), {
    method: "PATCH",
    headers: headers(userId),
    body: JSON.stringify({ photoId }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || "Cannot set avatar");
  }

  return await res.json().catch(() => null);
}